export default __webpack_public_path__ + "3e0c17e.png";